import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { erpStatusNoteSection } from "./urls";
import ErpStatusNoteComponent from "./views/erpStatusNote";

const erpstatusnote: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: string = qs;
  return <ErpStatusNoteComponent params={params} />;
};
export const ErpStatusNoteSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.erpstatusnote)} />
      <Switch>
        <Route exact path={erpStatusNoteSection} component={erpstatusnote} />
      </Switch>
    </>
  );
};
export default ErpStatusNoteSection;
